import { render } from "./MessageBalloon.vue?vue&type=template&id=1932f096&scoped=true&bindings={}"
import script from "./MessageBalloon.vue?vue&type=script&lang=ts"
export * from "./MessageBalloon.vue?vue&type=script&lang=ts"

import "./MessageBalloon.vue?vue&type=style&index=0&id=1932f096&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1932f096"

export default script